var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconTime48Line = function SvgIconTime48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.997 40.7a16.7 16.7 0 1 1 .005-33.4 16.7 16.7 0 0 1-.005 33.4Zm0-30A13.3 13.3 0 1 0 24 37.302a13.3 13.3 0 0 0-.002-26.6Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m28.088 30.45-4.94-5a2.85 2.85 0 0 1-.85-2v-8.47h3.4v8.27l4.8 4.79-2.41 2.41Z",
    fill: "current"
  })));
};
export default SvgIconTime48Line;